import {
    IImageThumbModalViewModel,
    IComment,
    ImageType,
    IImageProcessingComments,
    IOrderRow,
    IImageThumbnail,
    Resolution
} from '../Entities';
import ImageProcessingApi from '../api/ImageProcessingApi';
import { SAVE_PHOTOGRAPHER_UPLOAD_METADATA_SUCCESS } from '../../../../photographerupload/actions/PhotographerUploadActionTypes';
import { REFRESH_STITCH_IMAGES_STATUS } from '../../ActionTypes';
import { Translate } from '../../../../../shared/LanguageService';
import notify from '../../../../../shared/feedback/notifications';
import * as types from './ImageProcessingActionTypes';

export function clearState() {
    return (dispatch: (result: any) => void) =>
        dispatch({ type: types.CLEAR_IMAGEPROCESSING_STATE });
}

export function setCurrentOrder(orderId: number) {
    return { type: types.SET_IMAGE_PROCESSING_ORDER, orderId };
}

function listImagesSuccess(orderId: number, orderRows: IOrderRow[], imageType: number) {
    return imageType === ImageType.UNEDITED
        ? { type: types.LIST_UNEDITED_IMAGES_SUCCESS, orderId, result: orderRows }
        : { type: types.LIST_EDITED_IMAGES_SUCCESS, orderId, result: orderRows };
}

export function listImages(orderId: number, value: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.listImages(orderId, value).then((result: IOrderRow[]) => {
            dispatch(listImagesSuccess(orderId, result, value));
        });
}

function getImageSuccess(image: IImageThumbModalViewModel) {
    return { type: types.GET_IMAGE_SUCCESS, result: image };
}

export function getImageData(orderId: number, id: number) {
    return ImageProcessingApi.getEditedImage(orderId, id).then(
        (result: IImageThumbModalViewModel) => {
            return result;
        }
    );
}
export function getImage(orderId: number, id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ImageProcessingApi.getEditedImage(orderId, id).then((result: IImageThumbModalViewModel) => {
            dispatch(getImageSuccess(result));
        });
}

function getNewImageSuccess(imageViewModel: IImageThumbModalViewModel) {
    return { type: types.GET_NEW_IMAGE_SUCCESS, result: imageViewModel };
}

export function getLatestImage(orderId: number, id: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.getEditedImage(orderId, id).then((result: IImageThumbModalViewModel) => {
            dispatch(getNewImageSuccess(result));
            dispatch(getPhotoStatus(orderId));
        });
}

function saveCommentSuccess(comment: IComment) {
    return { type: types.SAVE_COMMENT_SUCCESS, result: comment };
}

export function saveComment(orderId: number, id: number, text: string, recipient: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.saveComment(orderId, id, text, recipient).then((result: IComment) => {
            dispatch(saveCommentSuccess(result));
        });
}

function saveNeedsEditingSuccess(imageId: number, needsEditing: boolean) {
    return {
        type: types.SAVE_NEEDS_EDITING_SUCCESS,
        result: { imageId: imageId, needsEditing: needsEditing }
    };
}

export function saveNeedsEditing(orderId: number, id: number, needsEditing: boolean) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.saveNeedsEditing(orderId, id, needsEditing).then((result: boolean) => {
            dispatch(saveNeedsEditingSuccess(id, result));
        });
}

function getImageProcessingInfoSuccess(orderId: number, result: any) {
    return { type: types.GET_IMAGE_PROCESSING_INFO_SUCCESS, orderId, result: result };
}

export function getImageProcessingInfo(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.getImageProcessingInfo(orderId).then((result: any) => {
            dispatch(getImageProcessingInfoSuccess(orderId, result));
            return result;
        });
}

function updateImageProcessingCommentSuccess(result: IImageProcessingComments) {
    return {
        type: types.UPDATE_IMAGE_PROCESSING_COMMENT_SUCCESS,
        result: result
    };
}

export function updateImageProcessingComment(orderId: number, text: string, type: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.updateImageProcessingComment(orderId, text, type).then(
            (result: IImageProcessingComments) => {
                dispatch(updateImageProcessingCommentSuccess(result));
            }
        );
}

export function checkIfImageExistsOnOrder(orderId: number, filename: string, orderRowId: number) {
    return ImageProcessingApi.checkIfImageExistsOnOrder(orderId, filename, orderRowId).then(
        (result: boolean) => {
            return result;
        }
    );
}

function getCategoriesSuccess(orderId: number, result: any) {
    return { type: types.GET_CATEGORIES_SUCCESS, orderId, result: result };
}

export function getCategories(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.getCategories(orderId).then((result: any) => {
            dispatch(getCategoriesSuccess(orderId, result));
        });
}

function updateCategorySuccess(result: any) {
    return { type: types.UPDATE_CATEGORY_SUCCESS, result: result };
}

export function isCustomer(role: string): boolean {
    return (
        role === 'role/broker-agent' ||
        role === 'role/broker-agent-assistant' ||
        role === 'role/broker-agent-admin'
    );
}

export function updateCategory(orderId: number, id: number, category: number) {
    return (dispatch: (result: any) => void, getState: () => any) => {
        let { user, imageProcessing } = getState();
        let orderRowlist = imageProcessing.edited.list;

        if (isCustomer(user.details.role)) {
            dispatch({
                type: types.COMMIT_LOCAL_CATEGORY_CHANGE_IMAGE,
                result: { orderId: orderId, imageId: id, category: category }
            });
        } else {
            ImageProcessingApi.updateCategory(orderId, id, category).then((result: any) => {
                dispatch(updateCategorySuccess(result));
            });
        }
    };
}

function swapCategoriesSuccess(result: any) {
    return { type: types.SWAP_CATEGORIES_SUCCESS, result: result };
}

export function swapCategories(
    orderId: number,
    id1: number,
    category1: number,
    id2: number,
    category2: number
) {
    return (dispatch: (result: any) => void, getState: () => any) => {
        let { user, imageProcessing } = getState();

        if (isCustomer(user.details.role)) {
            if (imageProcessing.photoStatus.canReapprove) {
                dispatch({
                    type: types.COMMIT_LOCAL_SWAP_IMAGES_CATEGORY,
                    result: { orderId: orderId, id1: id1, category1: category1, id2, category2 }
                });
            }
        } else {
            ImageProcessingApi.swapCategories(orderId, id1, category1, id2, category2).then(
                (result: any) => {
                    dispatch(swapCategoriesSuccess(result));
                }
            );
        }
    };
}

function updateImagesCategorySuccess(result: any) {
    return { type: types.UPDATE_IMAGES_CATEGORY_SUCCESS, result: result };
}

export function updateImagesCategory(orderId: number, imageIds: number[], category: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.updateImagesCategory(orderId, imageIds, category).then((result: any) => {
            dispatch(
                updateImagesCategorySuccess({
                    imageIds: imageIds,
                    categoryId: category,
                    status: result
                })
            );
        });
}

function deleteMultipleSuccess(result: any) {
    return { type: types.DELETE_MULTIPLE_SUCCESS, result: result };
}

export function deleteMultiple(orderId: number, imageIds: number[]) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.deleteMultiple(orderId, imageIds).then((result: any) => {
            dispatch(listImages(orderId, ImageType.UNEDITED));
            dispatch(listImages(orderId, ImageType.EDITED));
            dispatch(deleteMultipleSuccess(result));
        });
}

function returnMultipleSuccess(result: any) {
    return { type: types.RETURN_MULTIPLE_IMAGES_SUCCESS, result: result };
}

export function returnMultiple(
    orderId: number,
    imageIds: number[],
    text: string,
    recipients: number
) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.returnMultiple(orderId, imageIds, text, recipients).then(
            (result: any) => {
                dispatch(listImages(orderId, ImageType.EDITED));
                dispatch(returnMultipleSuccess(result));
            }
        );
}

export function downloadImage(orderId: number, imageId: number) {
    return ImageProcessingApi.downloadImage(orderId, imageId);
}

export function downloadDNGImage(orderId: number, imageId: number) {
    return ImageProcessingApi.downloadDNGImage(orderId, imageId);
}

function updateFilenameSuccess(result: string) {
    return { type: types.UPDATE_IMAGE_FILENAME_SUCCESS, result: result };
}

export function updateFilename(orderId: number, imageId: number, filename: string) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.updateFilename(orderId, imageId, filename).then((result: string) => {
            dispatch(updateFilenameSuccess(result));
        });
}

function getPhotoStatusSuccess(orderId: number, result: any) {
    return { type: types.GET_PHOTO_STATUS_SUCCESS, orderId, result: result };
}

export function getPhotoStatus(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.getPhotoStatus(orderId).then((result: any) => {
            dispatch(getPhotoStatusSuccess(orderId, result));
        });
}

function getSaveImageAsFavoriteSuccess(result: any) {
    return { type: types.GET_SAVE_IMAGE_AS_FAVORITE_SUCCESS, result };
}

export function saveImageAsFavorite(orderId: number, imageId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.saveImageAsFavorite(orderId, imageId).then((result: any) => {
            dispatch(getSaveImageAsFavoriteSuccess(result));
        });
}

function resetImageAsFavoriteSuccess(result: any) {
    return { type: types.RESET_IMAGE_AS_FAVORITE_SUCCESS, result };
}

export function resetImageAsFavorite(orderId: number, imageId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.resetImageAsFavorite(orderId, imageId).then((result: any) => {
            dispatch(resetImageAsFavoriteSuccess(result));
        });
}

function doneEditingImagesSuccess(result: any) {
    return { type: types.DONE_EDITING_IMAGES_SUCCESS, result: result };
}

export function doneEditingImages(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.doneEditingImages(orderId).then((result: any) => {
            dispatch(doneEditingImagesSuccess(result));
            dispatch(getPhotoStatus(orderId));
        });
}

function deliverOrderSuccess(result: any) {
    return { type: types.CREATE_DELIVERY_SUCCESS, result: result };
}

export function deliverOrder(
    orderId: number,
    message: string,
    date: Date,
    deliverOnlyToMail: string
) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.deliverOrder(orderId, message, date, deliverOnlyToMail).then(
            (result: any) => {
                dispatch(deliverOrderSuccess(result));
                dispatch(getPhotoStatus(orderId));
            }
        );
}

function redeliverOrderSuccess(result: any) {
    return { type: types.CREATE_REDELIVERY_SUCCESS, result: result };
}

export function redeliverOrder(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.redeliverOrder(orderId).then((result: any) => {
            dispatch(redeliverOrderSuccess(result));
            dispatch(getPhotoStatus(orderId));
        });
}

function overrideScheduledDeliverySuccess(result: any) {
    return { type: types.SCHEDULED_DELIVERY_OVERRIDDEN, result: result };
}

export function overrideScheduledDelivery(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.overrideScheduledDelivery(orderId).then((result: any) => {
            dispatch(overrideScheduledDeliverySuccess(result));
        });
}

function updateDeliverySuccess(result: any) {
    return { type: types.UPDATE_DELIVERY_SUCCESS, result: result };
}

export function updateDelivery(
    orderId: number,
    message: string,
    date: Date,
    deliverOnlyToMail: string
) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.updateDelivery(orderId, message, date, deliverOnlyToMail).then(
            (result: any) => {
                dispatch(updateDeliverySuccess(result));
            }
        );
}

function getDeliveryStatusForOrderSuccess(result: any) {
    return {
        type: types.GET_DELIVERY_STATUS_FOR_ORDER_SUCCESS,
        result: result
    };
}

export function getDeliveryStatusForOrder(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.getDeliveryStatusForOrder(orderId).then((result: any) => {
            dispatch(getDeliveryStatusForOrderSuccess(result));
        });
}

function customerApproveImagesSuccess(result: any) {
    return { type: types.CUSTOMER_APPROVE_SUCCESS, result: result };
}

function refreshAllowStitchStatus(result: boolean) {
    return { type: REFRESH_STITCH_IMAGES_STATUS, result: result };
}

export function customerApproveImages(orderId: number) {
    return (dispatch: (result: any) => void, getState: () => any) => {
        const { imageProcessing } = getState();

        let images: any[] = [];

        for (let i = 0; i < imageProcessing.edited.list.length; i++) {
            const orderRow = imageProcessing.edited.list[i];

            for (var j = 0; j < orderRow.thumbnails.length; j++) {
                const thumbnail: IImageThumbnail = orderRow.thumbnails[j];
                if (!thumbnail.isCustomerApproved) {
                    if (thumbnail.overrideProperties) {
                        images.push({
                            id: thumbnail.id,
                            category: thumbnail.overrideProperties.categoryId
                        });
                    } else {
                        images.push({
                            id: thumbnail.id,
                            category: thumbnail.categoryId
                        });
                    }
                }
            }
        }

        return ImageProcessingApi.customerApproveImages(
            orderId,
            images,
            imageProcessing.edited.extraSelected
        ).then((result: any) => {
            dispatch(getCategories(orderId));
            dispatch(
                customerApproveImagesSuccess({
                    photoStatus: result.photoStatus,
                    imageGalleryReference: result.imageGalleryReference
                })
            );
            dispatch(refreshAllowStitchStatus(result.allowStitchingOfEditingImages));
            dispatch(listImages(orderId, 1));
            dispatch(getPhotoStatus(orderId));
        });
    };
}

function customerReapproveImagesSuccess(result: any) {
    return { type: types.CUSTOMER_REAPPROVE_SUCCESS, result: result };
}

export function customerReapproveImages(orderId: number) {
    return (dispatch: (result: any) => void, getState: () => any) =>
        ImageProcessingApi.customerReapproveImages(orderId).then(() => {
            dispatch(customerReapproveImagesSuccess({ canReapprove: false }));
            dispatch(getPhotoStatus(orderId));
        });
}

function reDeliverImagesSuccess(result: any) {
    return { type: types.REDELIVER_IMAGES_SUCCESS, result: result };
}

export function reDeliverImages(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.reDeliverImages(orderId).then((result: any) => {
            dispatch(reDeliverImagesSuccess(result));
        });
}

export function resetDelivery(orderId: number) {
    return () => ImageProcessingApi.resetDelivery(orderId);
}

export function getZipDownloadLink(orderId: number, resolution: Resolution) {
    return ImageProcessingApi.getZipDownloadLink(orderId, resolution);
}

export function emailImages(orderId: number, resolution: Resolution) {
    return ImageProcessingApi.emailImages(orderId, resolution);
}

function getImageGalleryReferenceSuccess(result: any) {
    return { type: types.GET_IMAGE_GALLERY_REFERENCE_SUCCESS, result: result };
}

export function getImageGalleryReference(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.getImageGalleryReference(orderId).then((result: any) => {
            dispatch(getImageGalleryReferenceSuccess(result));
        });
}

function getContentProviderSuccess(orderId: number, result: any) {
    return { type: types.GET_CONTENT_PROVIDER_SUCCESS, orderId, result: result };
}

export function getContentProvider(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.getContentProvider(orderId).then((result: any) => {
            dispatch(getContentProviderSuccess(orderId, result));
        });
}

function createStitchedImageSuccess(result: any) {
    return { type: types.CREATE_STITCHED_IMAGE_SUCCESS, result: result };
}

export function createStitchedImage(
    leftStitchImageId: number,
    leftOffset: number,
    rightStitchImageId: number,
    rightOffset: number,
    orderId: number,
    orderRowId: number
) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.createStitchedImage(
            leftStitchImageId,
            leftOffset,
            rightStitchImageId,
            rightOffset,
            orderId,
            orderRowId
        ).then((result: any) => {
            dispatch(createStitchedImageSuccess(result));
        });
}

function deleteUneditedPhotoSuccess(photoId: number) {
    return { type: types.DELETE_UNEDITED_PHOTO_SUCCESS, result: photoId };
}

export function deleteUneditedPhoto(photoId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.deleteUneditedPhoto(photoId).then(() =>
            dispatch(deleteUneditedPhotoSuccess(photoId))
        );
}

function saveUploadsMetadataSuccess(idList: number[]) {
    return { type: SAVE_PHOTOGRAPHER_UPLOAD_METADATA_SUCCESS, result: idList };
}

export function saveUploadsMetadata(orderId: number, metadataList: any) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.saveMetaData(orderId, metadataList).then((idList: number[]) =>
            dispatch(saveUploadsMetadataSuccess(idList))
        );
}

function deleteFailedUploadedPhotoSuccess(photoUploadMetadataId: number) {
    return {
        type: types.DELETE_FAILED_PHOTO_SUCCESS,
        result: photoUploadMetadataId
    };
}

export function deleteFailedUploadedPhoto(photoUploadMetadataId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.deleteFailedUploadedPhoto(photoUploadMetadataId).then((result: any) =>
            dispatch(deleteFailedUploadedPhotoSuccess(photoUploadMetadataId))
        );
}

function photographerApprovePhotoOrderSuccess(photoStatus: any) {
    return {
        type: types.PHOTOGRAPHER_APPROVED_PHOTO_ORDER_SUCCESS,
        result: photoStatus
    };
}

export function photographerApprovePhotoOrder(photoOrderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.photographerApprovePhotoOrder(photoOrderId).then((result: any) =>
            dispatch(photographerApprovePhotoOrderSuccess(result))
        );
}

function deleteEditedPhotoSuccess(result: any) {
    return { type: types.DELETE_EDITED_PHOTO_SUCCESS, result: result };
}

export function deleteEditedPhoto(photoOrderId: number, photoId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.deleteEditedPhoto(photoOrderId, photoId).then((result: any) => {
            result.photoId = photoId;
            dispatch(deleteEditedPhotoSuccess(result));

            dispatch(listImages(photoOrderId, ImageType.EDITED));

            return;
        });
}

function getVitecBrokerSystemDeliveryInfoSuccess(result: any) {
    return {
        type: types.GET_VITEC_BROKER_SYSTEM_DELIVERY_INFO_SUCCESS,
        result: result
    };
}

export function getVitecBrokerSystemDeliveryInfo(photoOrderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.getVitecBrokerSystemDeliveryInfo(photoOrderId).then((result: any) =>
            dispatch(getVitecBrokerSystemDeliveryInfoSuccess(result))
        );
}

export function downloadMultipleExposures(orderId: number, imageIds: number[]) {
    return ImageProcessingApi.downloadMultipleExposures(orderId, imageIds);
}

function resetRejectionSuccess(result: any) {
    return { type: types.RESET_REJECTION_SUCCESS, result: result };
}

export function resetRejection(orderId: number) {
    return (dispatch: (result: any) => void) =>
        ImageProcessingApi.resetRejection(orderId).then((result: any) =>
            dispatch(resetRejectionSuccess(result))
        );
}

function updateImagesSortOrderIndexes(result: any) {
    return { type: types.UPDATE_IMAGES_SORT_ORDER_INDEXES, result: result };
}

export function updateImagesSortOrder(
    photoOrderId: number,
    sortOrder: any[],
    previousSortOrder: any[]
) {
    return (dispatch: (result: any) => void) => {
        dispatch(updateImagesSortOrderIndexes(sortOrder));
        ImageProcessingApi.updateImagesSortOrder(photoOrderId, sortOrder).catch((err) => {
            notify.failure(Translate('image-processing/page/fail-update-sort-order'));
            dispatch(updateImagesSortOrderIndexes(previousSortOrder));
        });
    };
}
